import { ENUM_HOME_LAYOUT } from './../../core/Utils/global';
import { ParametersService } from './../../core/services/parameters.service';
import { ParameterModel } from './../../core/interfaces/parameter.model';
import { Component, HostListener, OnInit } from '@angular/core';
import { CategoryModel, CategoryMoviesModel } from 'src/app/core/interfaces/category.model';
import { MovieModel } from 'src/app/core/interfaces/movie.model';
import { CategoriesService } from 'src/app/core/services/categories.service';
import { MoviesService } from 'src/app/core/services/movies.service';
import Swal from 'sweetalert2';
import { AuthService } from 'src/app/core/auth/auth.service';
import { MovieCategoryModel } from '../../core/interfaces/category.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-felix-oliver',
  templateUrl: './felix-oliver.component.html',
  styleUrls: ['./felix-oliver.component.scss']
})
export class FelixOliverComponent implements OnInit {

  public moviesSlideshow: CategoryMoviesModel;
  public moviesPerCategories: CategoryMoviesModel[] = [];

  loading = false;
  showFOBanner = true;

  constructor(
    private moviesService: MoviesService,
    private categoriesService: CategoriesService,
    private parametersService: ParametersService,
    private auth: AuthService,
  ) { }

  async ngOnInit() {
    this.loadFOBannerBoolean();
    await this.cargarDatos();
  }

  ngOnDestroy(): void {
  }

  async cargarDatos() {
    this.loading = true;

    // Peliculas en el slideshow
    let featureMovies = await this.categoriesService.GetFeaturedMoviesFelixOliver().toPromise();
    if (featureMovies) this.moviesSlideshow = featureMovies[0];


    //Categorias De FO
    let catsMovies = await this.categoriesService.getCategoriesMoviesFelixOliver().toPromise();
    if (catsMovies) this.moviesPerCategories = catsMovies;

    this.loading = false;

  }

  async loadFOBannerBoolean() {
    await this.parametersService.getFOBannerBoolean().then((res) => {
      if (res) {
        this.showFOBanner = true ? parseInt(res.value) == 1 : false;
      }
      else {
        this.showFOBanner = false;
      }
    }).catch((error) => {
      this.showFOBanner = false;
    })
  }

}
